import { defineMessages } from 'react-intl'

export default defineMessages({
  captionsOff: {
    id: 'common.video.captionsOff',
    defaultMessage: 'Off',
  },
  playbackRateTitle: {
    id: 'common.video.playbackRate',
    defaultMessage: 'Playback Speed',
  },
  close: {
    id: 'common.video.close',
    defaultMessage: 'Close',
  },
  back: {
    id: 'common.video.back',
    defaultMessage: 'Back',
  },

  featuredActors: {
    id: 'common.video.featuredActors',
    defaultMessage: 'Featured Actors',
  },

  nextEpisodeIn: {
    id: 'common.video.nextEpisodeIn',
    defaultMessage: 'Next Episode in {seconds, number}',
  },
  watchCredits: {
    id: 'common.video.watchCredits',
    defaultMessage: 'Watch Credits',
  },

  nextRecommendHeading: {
    id: 'common.video.nextRecommendHeading',
    defaultMessage: 'Something New?',
  },
  nextRecommendPlay: {
    id: 'common.video.nextRecommendPlay',
    defaultMessage: 'Watch Now',
  },
  nextRecommendDetails: {
    id: 'common.video.nextRecommendDetails',
    defaultMessage: 'Tell Me More',
  },

  videoErrorTitle: {
    id: 'common.video.error.title',
    defaultMessage: 'There was a problem playing this video',
  },
  videoNotFound: {
    id: 'common.video.error.notFound',
    defaultMessage: 'Video not found',
  },
  showingNext: {
    id: 'common.video.showigNext',
    defaultMessage: 'Showing\nNext:',
  },
  forbiddenTitle: {
    id: 'common.video.error.forbidden.title',
    defaultMessage: 'Lights, camera, uh-oh!\n You do not have access to this content.',
  },
  forbiddenBody: {
    id: 'common.video.error.forbidden.body',
    defaultMessage:
      'This could be because your rental has expired or the film is not available in your territory.\n Not to worry though – we have plenty of indie film gems for you to enjoy!',
  },
  goBack: {
    id: 'common.video.error.goBack',
    defaultMessage: 'Go Back',
  },
  channelPlayerErrorTitle: {
    id: 'common.channel.video.error.title',
    defaultMessage: 'CUT! We have a momentary glitch with this stream.',
  },
  channelPlayerErrorBody: {
    id: 'common.channel.video.error.body',
    defaultMessage:
      'While our crew is untangling the digital film reel, we have plenty more entertainment for you to enjoy!\n\n Thanks for your understanding.',
  },
})
